module.exports = __webpack_public_path__ + "img/mail.7facf59b.png";